var map = {
	"./Oval-border.svg": 8166,
	"./Oval-filled.svg": 13284,
	"./audio.svg": 25143,
	"./ear.svg": 56293,
	"./finish-exercise.svg": 62461,
	"./home.svg": 64278,
	"./login.svg": 81514,
	"./logo.svg": 3914,
	"./spinner.svg": 33126,
	"./success-day.svg": 89501,
	"./success-training.svg": 72623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36599;